import { Button, Card, Icon, Squircle, Typography, XStack, YStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { Check, Landmark, Wand } from 'lucide-react'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenConnectBankModal } from '@features/bankAccounts/hooks/useOpenConnectBankModal'
import { MastercardTrustNote } from '@features/openBanking/elements/MastercardTrustNote'
import { UiSource } from '@features/reconciliation/enums'

import { useSegment } from '../../../../../../hooks'
import * as Styled from './styles'

const upsellBenefitKeys = [
  'bank.accounts.list.card.upsell.benefits.transactions',
  'bank.accounts.list.card.upsell.benefits.balance',
  'bank.accounts.list.card.upsell.benefits.receipts',
] as const

export const BankUpsellCard = (): ReactElement => {
  const { t } = useTranslation()
  const openConnectBankModal = useOpenConnectBankModal()
  const { track } = useSegment()

  const handleConnectBankClick = useCallback(() => {
    track('Reconciliation Skip CSV Upload (Client)')
    openConnectBankModal(UiSource.SkipCsvUpload)
  }, [openConnectBankModal, track])

  return (
    <Styled.CardWrapper>
      <Card variant="subtle">
        <YStack padding={24} gap={16}>
          <XStack gap={12} align="center">
            <Squircle variant="primary" color="blue" type="icon" icon={<Icon icon={Wand} />} />
            <Styled.TitleWrapper>
              <Typography.Text size="large" weight="medium">
                {t('bank.accounts.list.card.upsell.title')}
              </Typography.Text>
            </Styled.TitleWrapper>
          </XStack>
          <YStack gap={8}>
            {upsellBenefitKeys.map((benefitKey) => (
              <XStack key={benefitKey} gap={8}>
                <Icon icon={Check} color={colors.content.neutral.bold} />
                <Typography.Text size="medium" color={colors.content.neutral.bold}>
                  {t(benefitKey)}
                </Typography.Text>
              </XStack>
            ))}
          </YStack>
          <XStack justify="space-between" align="flex-end">
            <MastercardTrustNote />
            <Button
              label={t('bank.accounts.list.card.actions.connect')}
              startIcon={<Icon icon={Landmark} />}
              size="large"
              variant="filled"
              onClick={handleConnectBankClick}
            />
          </XStack>
        </YStack>
      </Card>
    </Styled.CardWrapper>
  )
}
